import { useNavigate, useParams } from "react-router-dom";
import { PageHeader } from "@/components/page";
import { AgendaForm } from "@/components/agendas/AgendaForm";
import { RoleProtected } from "@/components/common/RoleProtected";
import { Button } from "@repo/ui/components/Base/Button";
import { useState } from "react";
import { AgendaSections } from "@/components/agendas/AgendaSections";
import { useDisableTeam } from "@/components/page/disableTeam";
import { useUserStore } from "@/stores/userStore";
import { useGetAgenda } from "@/hooks/queryHooks/agendaHooks";
import { useGetTenantByFriendly } from "@/hooks/queryHooks/tenantHooks";

export const AgendaPage = () => {
  const { meetingId, tenantId, agendaId } = useParams();
  const navigate = useNavigate();
  const activeTeam = useUserStore((s) => s.activeTeam);
  const activeTeamId =
    activeTeam && activeTeam !== "org" ? activeTeam.id : "org";

  useDisableTeam();

  const { data: tenantData } = useGetTenantByFriendly(tenantId ?? "");
  const { data: agendaData } = useGetAgenda(
    tenantData?.id ?? "",
    agendaId ?? ""
  );

  const teamMismatch = agendaData?.teamId != activeTeamId;

  const [agendaViewOnly, setAgendaViewOnly] = useState(true);

  if (!agendaData || !tenantData) return null;

  const handleEditAgenda = () => {
    setAgendaViewOnly(false);
  };

  const handleComplete = () => {
    setAgendaViewOnly(true);
  };

  const handleCancel = () => {
    setAgendaViewOnly(true);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col flex-grow">
      <PageHeader title={`${tenantData.name}: ${agendaData.name}`}>
        {" "}
      </PageHeader>
      <RoleProtected minRole="edit">
        <div className="flex flex-row justify-end pb-2">
          <Button
            tooltip={
              teamMismatch
                ? "You are in the wrong team to be editing this agenda"
                : "Edit Agenda"
            }
            onClick={handleEditAgenda}
            disabled={teamMismatch || !agendaViewOnly}
          >
            Edit
          </Button>
        </div>
      </RoleProtected>
      {tenantData?.id && (
        <div className="flex flex-row gap-4 justify-center">
          <div className="w-0 flex-grow-[2]">
            <AgendaForm
              viewOnly={agendaViewOnly}
              tenantId={tenantData.id}
              agendaFormData={agendaData}
              handleCancel={handleCancel}
              handleComplete={handleComplete}
              handleGoBack={handleGoBack}
            />
          </div>
          <div className="w-0 flex-grow">
            <AgendaSections
              tenantId={tenantData?.id}
              agenda={agendaData}
              meetingId={meetingId}
            />
          </div>
        </div>
      )}
    </div>
  );
};
